import React from "react";
import { useMediaQuery } from "react-responsive";
export const PokemonFilterElement = ({
  resetSearch,
  pokemonName,
  onClick,
  elemento,
  iconEl,
  elementColor,
}) => {
  const isTablet = useMediaQuery({ minWidth: 780, maxWidth: 1023 });
  const isMobile = useMediaQuery({ maxWidth: 779 });

  const style = {
    backgroundColor: `#${elemento.color}`,
    color: elementColor ? "white" : "black",
    border: elementColor ? "none" : "solid .6px gray",
    boxShadow: "2px 1px 5px rgba(0, 0, 0, 0.1)",
  };

  const IconEl = iconEl;
  const handleFiltroElement = () => {
    if (pokemonName.length > 0) {
      resetSearch("");
    }
    onClick(elemento.valueEl);
  };
  return (
    <>
      <button
        onClick={() => handleFiltroElement()}
        style={style}
        className={
          isMobile ? "element-mobile" : isTablet ? "elementBase" : "element"
        }
      >
        {!isTablet && !isMobile && elemento.elemento}

        {IconEl && <IconEl size={24} />}
      </button>
    </>
  );
};

export default PokemonFilterElement;
